import React from 'react';

function General() {
  return (
    <div>
      <p>[Général]</p>
    </div>
  );
}

General.propTypes = {};

export default General;
